import useAuth from "./useAuth";

import { getAuth, signOut } from "firebase/auth";

export default async function useLogOut(): Promise<void> {
  const { user } = useAuth();
  if (!user) {
    throw new Error("User not logged in");
  }

  signOut(getAuth());
  window.localStorage.removeItem("placeRef");
  window.localStorage.removeItem("marketing");
}
